"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const material_1 = require("@mui/material");
const react_2 = require("react");
const App_1 = require("../../App");
const api_1 = __importDefault(require("../../services/api"));
const react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
const Footer_1 = __importDefault(require("../../components/Footer"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Breadcrumbs_1 = __importDefault(require("@mui/material/Breadcrumbs"));
const Link_1 = __importDefault(require("@mui/material/Link"));
const Profile = () => {
    const [nomeFile, setNomeFile] = (0, react_2.useState)("");
    const [selectedFile, setSelectedFile] = (0, react_2.useState)();
    const [loading, setLoading] = (0, react_2.useState)(false);
    const [getFiles, setGetFiles] = (0, react_2.useState)(true);
    const [urlImage, setUrlImage] = (0, react_2.useState)("");
    const { user, backGroundColor, orgaoAUsar } = (0, react_2.useContext)(App_1.UserContext);
    (0, react_2.useEffect)(() => {
        if (getFiles && user.orderNo) {
            api_1.default
                .get("/brasao", {
                params: {
                    cliente: user.orderNo,
                },
            })
                .then((response) => {
                setUrlImage(response.data);
                setLoading(false);
                setGetFiles(false);
            });
        }
    }, [getFiles, user.orderNo]);
    const handleUpload = () => {
        // Create an object of formData
        const formData = new FormData();
        // Update the formData object
        if (selectedFile !== undefined) {
            formData.append("file", selectedFile);
        }
        setLoading(true);
        // Request made to the backend api
        // Send formData object
        api_1.default
            .post("/brasao", formData, {
            params: {
                orderNo: user.orderNo,
            },
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then(() => {
            react_toastify_1.toast.success("Upload de Brasão feita com sucesso", { draggablePercent: 60 });
            setSelectedFile(undefined);
            setLoading(false);
            setGetFiles(true);
        })
            .catch((error) => {
            react_toastify_1.toast.error(error, { draggablePercent: 60 });
        });
    };
    const VisuallyHiddenInput = (0, material_1.styled)("input") `
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
  `;
    return (react_1.default.createElement("div", { className: `page ${backGroundColor ? 'highContrast' : ''}` },
        react_1.default.createElement("div", { role: "presentation", style: { margin: "auto" } },
            react_1.default.createElement(Breadcrumbs_1.default, { "aria-label": "breadcrumb" },
                react_1.default.createElement(Link_1.default, { underline: "hover", color: "inherit", href: "/" }, "Home"),
                react_1.default.createElement(Link_1.default, { underline: "hover", color: "inherit", href: "/manutencao" }, "Manuten\u00E7\u00E3o"),
                react_1.default.createElement(Typography_1.default, { color: "text.primary" }, "Bras\u00E3o"))),
        react_1.default.createElement(react_toastify_1.ToastContainer, { draggable: true }),
        react_1.default.createElement("div", { className: "card__parent" },
            react_1.default.createElement("div", { className: "title" },
                react_1.default.createElement("p", null, `Brasão ${user.name}`)),
            react_1.default.createElement("div", { className: "", style: {
                    margin: "auto",
                    textAlign: "center",
                    paddingTop: "10px",
                    height: "50px",
                    color: "#31708f",
                    backgroundColor: "#d9edf7",
                    borderColor: "#bce8f1",
                    width: "50%",
                    display: `${selectedFile ? "none" : ""}`,
                    marginBottom: "10px",
                } },
                react_1.default.createElement("strong", null, "Informa\u00E7\u00E3o"),
                " ",
                react_1.default.createElement("br", null),
                "Selecione um arquivo para realizar o upload!"),
            react_1.default.createElement("div", { className: "flex__firstRow", style: { display: "flex", flexDirection: "row", marginBottom: "20px", margin: "auto" } },
                react_1.default.createElement("div", { className: "firstRow__field ", style: { marginTop: 20, marginLeft: 20 } },
                    react_1.default.createElement(material_1.Button, { component: "label", variant: "contained", href: "#file-upload" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFile, style: { marginRight: 7 } }),
                        "Selecione a imagem do Bras\u00E3o",
                        react_1.default.createElement(VisuallyHiddenInput, { type: "file", onChange: (e) => {
                                if (e.target && e.target instanceof HTMLInputElement && e.target.files) {
                                    const file = e.target.files[0];
                                    setSelectedFile(file);
                                    setNomeFile(file.name);
                                    setUrlImage(URL.createObjectURL(file));
                                }
                            } })),
                    react_1.default.createElement("p", { style: { marginTop: 2 } }, nomeFile)),
                react_1.default.createElement("div", { className: "modal__brasao" },
                    react_1.default.createElement("img", { alt: "bras\u00E3o", src: urlImage, className: "modal__brasao" }))),
            react_1.default.createElement("div", { className: "flexRow", style: { display: "flex", flexDirection: "row", margin: "auto" } },
                react_1.default.createElement("div", { className: "button", style: { marginTop: 20, marginLeft: 20 } },
                    react_1.default.createElement(material_1.Button, { variant: "contained", disabled: nomeFile === "" || selectedFile === undefined, onClick: handleUpload },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faUpload }),
                        react_1.default.createElement("span", { className: "p10_left" }, "salvar"))),
                loading && react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(material_1.CircularProgress, null),
                    " ",
                    react_1.default.createElement("p", { className: "search__check ", style: { paddingLeft: "15px", fontSize: "15px" } }, "Esta consulta pode demorar alguns minutos")))),
        react_1.default.createElement(Footer_1.default, null)));
};
exports.default = Profile;
